import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

type Props = SvgIconProps;

const BurgerMenuIcon: React.FC<Props> = (props) => {
  return (
    <SvgIcon viewBox="0 0 18 19" {...props}>
      <path
        d="M16 0.5H2C0.9 0.5 0 1.4 0 2.5V16.5C0 17.6 0.9 18.5 2 18.5H16C17.1 18.5 18 17.6 18 16.5V2.5C18 1.4 17.1 0.5 16 0.5ZM9 9.5C7.34 9.5 6 8.16 6 6.5C6 4.84 7.34 3.5 9 3.5C10.66 3.5 12 4.84 12 6.5C12 8.16 10.66 9.5 9 9.5Z"
        fill="#B8BEC9"
      />
      <path d="M8 6H7V7H8V6Z" fill="#B8BEC9" />
      <path d="M9.5 6H8.5V7H9.5V6Z" fill="#B8BEC9" />
      <path d="M11 6H10V7H11V6Z" fill="#B8BEC9" />
    </SvgIcon>
  );
};

export default BurgerMenuIcon;
